import { CurriculumLibrariesActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    curriculumLibrariesList: null,
    curriculumLibrariesListDetails: null,
    deleted_curriculumLibrariesList: null,
    saved_curriculumLibrariesList: null,
    uploadCSVDocumentsForDCMessage: null,
    archiveBatchDCStatus: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CurriculumLibrariesActionTypes.get_curriculumLibrariesList.REQUEST:
            return {
                ...state,
                loading: true,
                curriculumLibrariesList: null
            };
        case CurriculumLibrariesActionTypes.get_curriculumLibrariesList.SUCCESS:
            return {
                ...state,
                loading: false,
                curriculumLibrariesList: payload
            };
        case CurriculumLibrariesActionTypes.get_curriculumLibrariesDetails.REQUEST:
            return {
                ...state,
                loading: true,
                curriculumLibrariesListDetails: null
            };
        case CurriculumLibrariesActionTypes.get_curriculumLibrariesDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                curriculumLibrariesListDetails: payload
            };
        case CurriculumLibrariesActionTypes.post_curriculumLibraries.REQUEST:
            return {
                ...state,
                loading: true,
                saved_curriculumLibrariesList: null
            };
        case CurriculumLibrariesActionTypes.post_curriculumLibraries.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_curriculumLibrariesList: payload
            };
        case CurriculumLibrariesActionTypes.delete_curriculumLibraries.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_curriculumLibrariesList: null
            };
        case CurriculumLibrariesActionTypes.delete_curriculumLibraries.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_curriculumLibrariesList: payload
            };
        case CurriculumLibrariesActionTypes.post_UploadCSVDocumentsForDC.REQUEST:
            return {
                ...state,
                loading: true,
                uploadCSVDocumentsForDCMessage: null,
            };
        case CurriculumLibrariesActionTypes.post_UploadCSVDocumentsForDC.FAILURE:
            return {
                ...state,
                loading: false,
                uploadCSVDocumentsForDCMessage: payload,
            };
        case CurriculumLibrariesActionTypes.archive_batchDCStatus.REQUEST:
            return {
                ...state,
                loading: true,
                archiveBatchDCStatus: null
            };
        case CurriculumLibrariesActionTypes.archive_batchDCStatus.SUCCESS:
            return {
                ...state,
                loading: false,
                archiveBatchDCStatus: payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/reducers/curriculumLibrariesReducer.js